import styled from 'styled-components';
import { Button } from 'reactstrap';

export const Wrapper = styled.section`
  background: #ffffff;
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 4px;
  border: 1px solid #e5e5e5;
  width: 670px;
`;

export const StyledSubTitle = styled.p`
  font-weight: normal;
  font-size: 15px;
  line-height: 24px;
  margin: 5px 0;
`;

export const StyledSceneList = styled.div`
  display: flex;
  flex-direction: row;
  overflow-y: scroll;
  width: 620px;
`;

export const StyledSceneListItem = styled.div`
  margin-right: 10px;
`;

export const StyledControlAction = styled.div`
  display: flex;
  padding: 20px;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  margin-top: 20px;
`;

export const StyledOptionAction = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  padding: 0;
  font-size: 12px;
  input {
    margin-right: 4px;
    position: relative;
  }
`;

export const StyledControlContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-top: 20px;
  justify-content: right;
`;

export const StyledNotification = styled.div`
  justify-content: left;
  flex: 6;
`;

export const StyledGroupButtonActions = styled.div`
  margin-left: 20px;
  justify-content: space-between;
`;

export const StyledButtonAction = styled(Button)`
  border: 1px solid #dfe3ec;
  margin-left: 10px;
  font-size: 14px;
  ${({ $isDefaultColor }) =>
    $isDefaultColor &&
    `
  background: #ffffff;
  color: #33373d;
  `};
`;
